import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B090015FindRequest = {
  sokoCd: string;
  shohinCd: string;
  locationCd: string;
} & Partial<{
  torihikiYmdFrom: string;
  torihikiYmdTo: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B090015FindResponse = {
  crtDate: string;
  shainNm: string;
  ukeharaiKbnNm: string;
  ukeiresu: string;
  haraidashisu: string;
  torihikiYmd: string;
  aitesakisokoCd: string;
  aitesakisokoNmr: string;
  meisaibiko: string;
};

export const B090015Find = (props: B090015FindRequest) => {
  return RestClient.get<PageableResponse<B090015FindResponse[]>>(
    "b090015/find",
    {
      params: props,
    }
  );
};
